import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([ Navigation ]);

export default class Testimonials {
    constructor() {
        if ($('.js-testimonials').length) {
            const $slider = $('.js-testimonials__slider');

            const testimonials = new Swiper($slider[0], {
                autoHeight: true,
                navigation: {
                    enabled: true,
                    nextEl: '.js-testimonials__nav .swiper-button-next',
                    prevEl: '.js-testimonials__nav .swiper-button-prev',
                },
                slidesPerView: 1
            });

            testimonials.init();
        };
    };
};
